export class ChangePasswordAction {
  static type = '[USER] Change password';

  constructor(readonly oldPassword: string | null, readonly newPassword: string, readonly newPassword2: string) {}
}
